<!-- Contenu principal -->
<div class="dash-content">
  <div class="dash-main-content">

    <!-- Titre & actions -->
    <div class="dash-top">
      <h2 class="dash-title">Historique</h2>

      <div class="dash-action">
        <div class="dash-action-left">
          <!-- Filtre Type d'opération -->
          <div class="select-wrapper">
            <select name="operationType"
              id="operationType"
              (change)="filterByOperation($event)">
              <option value="">Toutes les opérations</option>
              <option value="CREATE">Affectation</option>
              <option value="DELETE">Retrait</option>
              <option value="UPDATE">Modification</option>
            </select>
          </div>

          <!-- Filtre Admins/Auteur -->
          <div class="select-wrapper">
            <select name="adminFilter"
              id="adminFilter"
              (change)="filterByAdmin($event)">
              <option value="">Tous les utilisateurs</option>
              @for (admin of adminsList; track admin) {
                <option
                  [value]="admin.id">
                  {{ admin.firstName }} {{ admin.lastName }} {{ admin.username }}
                </option>
              }
            </select>
          </div>

          <!-- Filtre Période -->
          <div class="select-wrapper">
            <select name="periodFilter"
              id="periodFilter"
              [(ngModel)]="selectedPeriod"
              (change)="onPeriodChange()">
              <option value="">Toute la période</option>
              <option value="today">Aujourd'hui</option>
              <option value="week">Cette semaine</option>
              <option value="month">Ce mois</option>
              <option value="calendar">Choisir une date</option>
            </select>
          </div>

          <button class="button button-icon primary" (click)="loadHistoriques()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 17.5L22 22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
            </svg>
            <span>Recherche</span>
          </button>
        </div>
        <!-- <div class="dash-action-right">
        <div *ngIf="isLoading" class="loading-indicator">
          <span>Chargement...</span>
        </div>
      </div>-->
    </div>
  </div>

  <!-- Tableau des événements -->
  @if (!isLoading && filteredEvents.length > 0) {
    <table class="table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Rôle</th>
          <th>Auteur</th>
          <th>Cible</th>
        </tr>
      </thead>
      <tbody>
        @for (event of paginatedEvents; track event) {
          <tr>
            <td>
              {{ formatDate(event.time) }} à
              <span class="text-gray">{{ formatTime(event.time) }}</span>
            </td>
            <td>
              <div class="badge"
                [ngClass]="getOperationClass(event.operationType)">
                {{ getOperationLabel(event.operationType) }}
              </div>
            </td>
            <td>
              <span class="text-purple fw-700">
                {{ getRoleName(event) }}
              </span>
            </td>
            <td>
              {{ getAuthorName(event) }}
            </td>
            <td>
              {{ getTargetName(event) }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  <!-- Message si aucun événement -->
  @if (!isLoading && filteredEvents.length === 0) {
    <div class="no-data-message">
      Aucun événement trouvé pour les critères sélectionnés.
    </div>
  }

  <!-- Message pendant le chargement -->
  @if (isLoading) {
    <div class="loading-message">
      Chargement de l'historique...
    </div>
  }

  <!-- Pagination -->
  @if (!isLoading && totalPages > 1) {
    <div class="paginate">
      <!-- Bouton précédent -->
      <a
        (click)="goToPreviousPage()"
        [class.disabled]="currentPage === 0"
        class="paginate-arrow left">
        <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            [attr.stroke]="currentPage === 0 ? '#CCCCCC' : 'black'"
            d="M4.27 7.81L0.75 4.28L4.27 0.75"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"/>
          </svg>
        </a>
        <!-- Numéros de page -->
        <ul class="paginate-item">
          <!-- Version simplifiée avec getDisplayPages() -->
          @for (page of getDisplayPages(); track page) {
            <li
              [class.is-active]="page === currentPage + 1"
              [class.dots]="page === '...'">
              @if (page !== '...') {
                <a (click)="goToPage(page - 1)">{{ page }}</a>
              }
              @if (page === '...') {
                <span>...</span>
              }
            </li>
          }
        </ul>
        <!-- Bouton suivant -->
        <a
          (click)="goToNextPage()"
          [class.disabled]="currentPage === totalPages - 1"
          class="paginate-arrow right">
          <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              [attr.stroke]="currentPage === totalPages - 1 ? '#CCCCCC' : '#5E5E5E'"
              d="M0.75 7.81L4.27 4.28L0.75 0.75"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      }
      <!-- Fin pagination -->

    </div>
  </div>
  <!-- Fin contenu principal -->

  <script src="assets/javascript/app.js"></script>
